import checkAccessToken from './check-access-token';
import { EXPIRY_THRESHOLD, REFRESHING_TOKEN_KEY, VISIBLE_VISIBILITY_STATE } from '../constants';
const setupCheckAccessToken = async client => {
  if (typeof window === 'undefined' || !client) return;
  window.localStorage.removeItem(REFRESHING_TOKEN_KEY);
  const checkToken = () => checkAccessToken(client);
  const tokenCheck = checkToken();
  const tokenInterval = setInterval(checkToken, EXPIRY_THRESHOLD * 1000);
  window.addEventListener('beforeunload', () => {
    window.localStorage.removeItem(REFRESHING_TOKEN_KEY);
    clearInterval(tokenInterval);
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === VISIBLE_VISIBILITY_STATE) checkToken();
  }, false);
  return tokenCheck;
};
export default setupCheckAccessToken;
//# sourceMappingURL=setup-check-access-token.js.map